import React, { useEffect, useState } from "react";
import { MolecularBg } from "../components/MolecularBg";
import { StarRating } from "../components/StarRating";
import { BadgeCheck } from "lucide-react";
import api from "../lib/api";

export const ReviewsPage = () => {
    const [products, setProducts] = useState([]);
    const [allReviews, setAllReviews] = useState([]);

    useEffect(() => {
        api.get("/products").then(async (r) => {
            setProducts(r.data);
            const reviewPromises = r.data.slice(0, 8).map((p) => api.get(`/reviews/${p.slug}`).then((rr) => ({ slug: p.slug, name: p.name, ...rr.data })));
            const results = await Promise.all(reviewPromises);
            const flat = results.flatMap((res) => res.reviews.map((rv) => ({ ...rv, product_name: res.name, product_slug: res.slug })));
            flat.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setAllReviews(flat);
        });
    }, []);

    const avg = allReviews.length
        ? (allReviews.reduce((s, r) => s + r.rating, 0) / allReviews.length).toFixed(1)
        : "5.0";

    return (
        <div className="pt-28 pb-20 min-h-screen relative" data-testid="reviews-page">
            <MolecularBg intensity="medium" />
            <div className="container-x relative z-10">
                <span className="eyebrow">// Trusted by researchers worldwide</span>
                <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white tracking-tighter mt-2 mb-4">
                    All Reviews
                </h1>
                <div className="flex items-center gap-4 mb-12">
                    <div className="font-display text-3xl font-bold text-[var(--neon-cyan)]">{avg}</div>
                    <StarRating value={parseFloat(avg)} size={18} />
                    <span className="text-sm font-mono uppercase tracking-widest text-[var(--text-muted)]">
                        from {allReviews.length} reviews
                    </span>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {allReviews.map((r) => (
                        <div key={r.id} className="glass-elevated rounded-2xl p-5" data-testid={`global-review-${r.id}`}>
                            <div className="flex items-center justify-between mb-2">
                                <StarRating value={r.rating} size={14} />
                                {r.verified_purchase && (
                                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-mono uppercase tracking-widest border border-emerald-500/30 bg-emerald-500/10 text-emerald-300">
                                        <BadgeCheck size={10} /> Verified
                                    </span>
                                )}
                            </div>
                            <h4 className="font-display font-bold text-white mb-1">{r.title}</h4>
                            <p className="text-sm text-[var(--text-secondary)] leading-relaxed mb-3 line-clamp-3">{r.body}</p>
                            <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)]">
                                {r.customer_name} on <span className="text-[var(--neon-cyan)]">{r.product_name}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
